var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"multiple":"multiple"}})])}
var staticRenderFns = []

export { render, staticRenderFns }